import { Component, OnInit } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  CustomResultOfPaginatedListOfGetUserValueOfPurchasesWithPaginationDto,
  GetCurrentUserDailyValueOfPurchaseAlertSettingDto,
  GetEnumValuesDto,
  GetUserValueOfPurchasesWithPaginationDto,
} from 'src/app/core/api/models';
import {
  UserDailyValueOfPurchaseAlertSettingService,
  UserValueOfPurchasesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { BaseIndexModule } from 'src/app/pages/shared/base';
import { PeriodicDateConfig } from 'src/app/shared/components/periodic-date-picker/periodic-date-picker.component';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { ValueOfPurchaseAlertSettingFormComponent } from './value-of-purchase-alert-setting-form/value-of-purchase-alert-setting-form.component';

@Component({
  selector: 'app-value-of-purchases',
  templateUrl: './value-of-purchases.component.html',
  imports: [BaseIndexModule, ValueOfPurchaseAlertSettingFormComponent],
})
export class ValueOfPurchasesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.valueOfPurchases;

  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetUserValueOfPurchasesWithPaginationDto>;
  items$: Observable<Array<GetUserValueOfPurchasesWithPaginationDto>>;
  isShowAlertSetting: boolean;
  alertSettingData: GetCurrentUserDailyValueOfPurchaseAlertSettingDto;
  startDateTime: string = DateTimeService.getSomeDaysAgo(30, true).toUTC();
  endDateTime: string = DateTimeService.getTodayDate().toUTC();
  periodicDateConfig: PeriodicDateConfig;

  RecentSendDifferenceWithFrequencyStatusEnumValues: GetEnumValuesDto[] = [];
  UserValueOfPurchaseIndexEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(
    protected currentService: UserValueOfPurchasesService,
    protected valueOfPurchaseAlertSettingService: UserDailyValueOfPurchaseAlertSettingService
  ) {
    super();
  }
  ngOnInit() {
    this.setComponentsConfig();
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showAddBtn = false;
    this.pageConfig.tableConfig.showOperationColumn = false;
  }

  setDefaultTableSort(): void {
    this.sortObject.push({ columnName: 'totalPoint', sort: 1 });
  }

  getEnumsValues() {
    this.getEnumValuesApi('RecentSendDifferenceWithFrequencyStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) =>
          (this.RecentSendDifferenceWithFrequencyStatusEnumValues = values)
      );
    this.getEnumValuesApi('UserValueOfPurchaseIndex')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) => (this.UserValueOfPurchaseIndexEnumValues = values)
      );
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.strategyTitle',
        name: 'strategyTitle',
        hasSearch: true,
        wrap: true,
      },
      {
        title: 'common.userName',
        name: 'userName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: 'common.organizationName',
        name: 'organizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}totalUsedCredit`,
        name: 'totalUsedCredit',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}realUsedCredit`,
        name: 'realUsedCredit',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}totalSentCount`,
        name: 'totalSentCount',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}realSentCount`,
        name: 'realSentCount',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}totalSentParts`,
        name: 'totalSentParts',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}realSentParts`,
        name: 'realSentParts',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}usedCreditPerEachFrequency`,
        name: 'usedCreditPerEachFrequency',
        wrap: true,
        type: 'number',
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}sendSmsFrequency`,
        name: 'sendSmsFrequency',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },

      {
        title: `${this.tableVocabs}recentSendDifferenceWithFrequencyStatus`,
        name: 'recentSendDifferenceWithFrequencyStatus',
        hasSearch: true,
        type: 'enum',
        enumName: 'RecentSendDifferenceWithFrequencyStatus',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}totalPoint`,
        name: 'totalPoint',
        hasSearch: true,
        wrap: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}points`,
        name: 'points',
        hasSearch: false,
        noSorting: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}recentSendSms`,
        name: 'recentSendSms',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }


  setComponentsConfig() {
    try {
      this.periodicDateConfig = {
        startDateLabel: 'common.startDate',
        endDateLabel: 'common.endDate',
        responsiveClassName: 'sm:tw-w-1/2',
        isEditMode: this.formPageConfig?.isEditMode,
        isShowEndDate: true,
        isShowStartDate: true,
        startDateValue: DateTimeService.getSomeDaysAgo(30, true).toUTC(),
        endDateValue: DateTimeService.getTodayDate().toUTC(),
      };
    } catch (error) {
      this.loggerService.logError(
        'app-base-statistical-form',
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetUserValueOfPurchasesWithPaginationDto> {
    return this.currentService.userValueOfPurchasesGetUserValueOfPurchasesWithPagination(
      {
        body: {
          ...this.getBaseModelWithPaginationParams(),
          startDateTime: this.startDateTime,
          endDateTime: this.endDateTime,
        },
      }
    );
  }

  setDateTime(value, type: 'startDate' | 'endDate') {
    if (type == 'startDate') this.startDateTime = DateTimeService.toUTC(value);
    else this.endDateTime = DateTimeService.toUTC(value);
  }

  //#endregion

  onClearQueryString() {
    this.getComparisonObjects(this.convertFilters(), true);
    this.getSortItems(this.convertSort(), true);
    this.changePageSize(30, true);
    super.ngOnInit(false, false);
    this.setDefaultTableSort();
  }

  onAlertSetting() {
    this.unSubs();
    this.pageConfig.loading = true;

    this.valueOfPurchaseAlertSettingService
      .userDailyValueOfPurchaseAlertSettingGetCurrentUserDailyValueOfPurchaseAlertSetting()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          this.alertSettingData = res.data;
          this.isShowAlertSetting = true;
        }
      });
  }

  onSearch() {
    this.getTableData();
  }
}
